module.exports = __webpack_public_path__ + "static/media/mth.132f3005.svg";